import { defineStore } from 'pinia'
import { ref } from "vue";

export const useProductsStore = defineStore('products', () => {
    const products = ref([]);
    const loading = ref(false);

    const fetch = async () => {
        loading.value = true

        try {
            const response = await axios.get('/api/store/products');
            products.value = response.data.data;
        } catch (error) {
            console.error(error);
        } finally {
            loading.value = false
        }
    }

    return {
        products,
        fetch
    }
})
